export const environment = {
  production: false,
  URL_BACKEND: 'https://dev.gateway.gondola.tiendasisimo.com',
  GOOGLE_COOKIE: 'gondola_session',
  GOOGLE_CLIENT_ID: '',
};
